class ChatBodyHelper {
  static Room(State = {}) {
    const { Tab, RoomId, Name, Users = [], Customers = [] } = State;
    const processedUsers = Users?.length > 0 ? Users.map((u) => u.value) : [];
    const processedCustomers =
      Customers?.length > 0 ? Customers.map((u) => u.value) : [];
    switch (Tab) {
      case "Create":
        return {
          Name,
          Users: processedUsers,
          Customers: processedCustomers,
        };
      case "Edit":
        return {
          RoomId,
          body: {
            Name,
            Users: processedUsers,
            Customers: processedCustomers,
          },
        };
      default:
        return { RoomId };
    }
  }
}

export default ChatBodyHelper;
